module.exports = __webpack_public_path__ + "public/img/energy1.75734347.png";